import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ContinueToNextViewButton } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ContinueToNextViewButton";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useHCaptchaLogin } from "@faire/retailer-visitor-shared/hooks/hCaptcha/useHCaptchaLogin";
import { MIN_PASSWORD_LENGTH } from "@faire/retailer-visitor-shared/lib/consts";
import { useSSOPasswordStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOPasswordStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Avatar } from "@faire/web--source/slate/deprecated/Avatar";
import { Eye, EyeClosed } from "@faire/web--source/slate/icons/foundation/Eye";
import { Input } from "@faire/web--source/slate/Input";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSigninTriggersMfaSubmit } from "@faire/web-api--source/events/signin/submit/triggersMfa";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { LoginState } from "@faire/web-api--source/indigofair/data/LoginState";
import React, { useCallback, useState } from "react";
import styled from "styled-components";
export var ConfirmPasswordView = function(param) {
    var email = param.email, profileImage = param.profileImage, userName = param.userName, onComplete = param.onComplete, onLogin = param.onLogin;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(""), 2), password = _useState[0], setPassword = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), hidePassword = _useState1[0], setHidePassword = _useState1[1];
    var _useState2 = _sliced_to_array(useState(), 2), inputError = _useState2[0], setInputError = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), error = _useState3[0], setError = _useState3[1];
    var ssoToken = useSSOStore().ssoToken;
    var setShowConfirmPasswordView = useSSOPasswordStore().setShowConfirmPasswordView;
    var _useState4 = _sliced_to_array(useState(false), 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var hCaptchaLogin = useHCaptchaLogin().hCaptchaLogin;
    var handleInputChange = function(event) {
        var _event_currentTarget;
        var _event_currentTarget_value;
        setPassword((_event_currentTarget_value = (_event_currentTarget = event.currentTarget) === null || _event_currentTarget === void 0 ? void 0 : _event_currentTarget.value) !== null && _event_currentTarget_value !== void 0 ? _event_currentTarget_value : "");
        setInputError(undefined);
    };
    var toggleHidePassword = function() {
        return setHidePassword(!hidePassword);
    };
    var onContinue = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var loginRequest, _ref, user, mfa_description, mfa_title, mfa_options, login_state, e, loginError, _loginError_message;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (password.length < MIN_PASSWORD_LENGTH) {
                            setInputError(strictLocalize({
                                id: "LS2IIS",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Password too short"
                                    }
                                ]
                            }));
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        loginRequest = ILoginRequest.build({
                            sso_token: ssoToken,
                            password: password,
                            enable_mfa_method_selection: true
                        });
                        setIsLoading(true);
                        return [
                            4,
                            hCaptchaLogin(loginRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), user = _ref.user, mfa_description = _ref.mfa_description, mfa_title = _ref.mfa_title, mfa_options = _ref.mfa_options, login_state = _ref.login_state;
                        if (login_state === LoginState.MFA_METHOD_SELECTION_REQUIRED) {
                            trackSigninTriggersMfaSubmit("CONFIRM_PASSWORD");
                            onComplete({
                                nextView: View.SELECT_MFA_OPTION,
                                password: password,
                                mfaOptions: mfa_options,
                                mfaTitle: mfa_title,
                                mfaDescription: mfa_description
                            });
                            return [
                                2
                            ];
                        }
                        if (login_state === LoginState.MFA_REQUIRED) {
                            trackSigninTriggersMfaSubmit("CONFIRM_PASSWORD");
                            onComplete({
                                nextView: View.ENTER_MFA,
                                password: password,
                                mfaDescription: mfa_description,
                                mfaTitle: mfa_title
                            });
                            return [
                                2
                            ];
                        }
                        if (!user) {
                            setError(strictLocalize({
                                id: "6Qgt73",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Invalid credentials"
                                    }
                                ]
                            }));
                            return [
                                2
                            ];
                        }
                        setShowConfirmPasswordView(false);
                        onLogin(user);
                        onComplete({
                            nextView: View.LOADING
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        loginError = convertErrorToLoginError(e, strictLocalize);
                        if (loginError.httpStatusCode === 429) {
                            setError(strictLocalize({
                                id: "S8h6wQ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Exceeded maximum allowed number of login attempts"
                                    }
                                ]
                            }));
                        } else {
                            ;
                            setError((_loginError_message = loginError.message) !== null && _loginError_message !== void 0 ? _loginError_message : strictLocalize({
                                id: "8GvVWZ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Something went wrong, please try again."
                                    }
                                ]
                            }));
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    var LinkFormatting = useCallback(function(chunks) {
        return /*#__PURE__*/ _jsx(EmbeddedLink, {
            onClick: function() {
                return onComplete({
                    nextView: View.RESET_PASSWORD
                });
            },
            children: chunks
        });
    }, [
        onComplete
    ]);
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            !!(profileImage === null || profileImage === void 0 ? void 0 : profileImage.url) || userName ? /*#__PURE__*/ _jsx(Column, {
                align: "flex-start",
                children: /*#__PURE__*/ _jsx(Avatar, {
                    image: profileImage,
                    size: "medium",
                    userName: userName
                })
            }) : null,
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "nl2qUm",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Confirm Faire password"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "SaQ8Se",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Continue as "
                        },
                        {
                            type: 1,
                            value: "retailerEmailAddress"
                        }
                    ],
                    values: {
                        retailerEmailAddress: email
                    }
                })
            }),
            error ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.critical,
                        children: error
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Input, {
                label: strictLocalize({
                    id: "A3LsA2",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter Password"
                        }
                    ]
                }),
                value: password,
                name: "enter_password",
                type: hidePassword ? "password" : undefined,
                error: inputError,
                onChange: handleInputChange,
                suffixNode: /*#__PURE__*/ _jsx("button", {
                    onClick: toggleHidePassword,
                    children: hidePassword ? /*#__PURE__*/ _jsx(Eye, {
                        fontSize: "16px"
                    }) : /*#__PURE__*/ _jsx(EyeClosed, {
                        fontSize: "16px"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "sSUqKx",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Forgot your password? "
                        },
                        {
                            type: 8,
                            value: "LinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Reset It"
                                }
                            ]
                        }
                    ],
                    values: {
                        LinkFormatting: LinkFormatting
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Continue, {
                onClick: onContinue,
                isLoading: isLoading
            })
        ]
    });
};
var Continue = styled(ContinueToNextViewButton).withConfig({
    componentId: "sc-77bf234d-0"
})([
    "width:100%;"
]);
